import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom"

import { Box, Text, Button, Layer, Heading } from 'grommet';
import { StatusGood, StatusCritical } from "grommet-icons"
import TTJsonTree from './TTJsonTree';


export const ErrorStatusNotification = ({ header, error_message, disclaimer, parameters=""}) => {

    const [formParams, setFormParams] = useState({})

    let borderStyle = { size: "medium", side: "all", color: "ttdown" }
    
    useEffect(() => {
        if(parameters && parameters.length > 0 && typeof parameters === "string"){
            let parsedParams = JSON.parse(parameters)
            setFormParams(parsedParams)
        }
    }, [parameters])


    return (
        <Layer position="center" modal >
        <Box 
            pad="medium" gap="small" width="450px" height="450px" align="center" 
            alignContent="center" alignSelf="center" background="light-1"
            border={borderStyle}
        >
            <Heading level={4} margin={{ top: "30px", bottom: "15px" }} align="center" color="ttdown" textAlign="center">
                {header}
            </Heading>
            <Text size="medium" color="black" margin={{ top: "15px", bottom: "5px" }}>{error_message}</Text>

            {Object.keys(formParams).length > 0 && 
                <TTJsonTree data={formParams} expandAll={true}/>
            }
            <Text size="small" color="brand" weight="lighter" margin={{ top: "30px", bottom: "5px" }}>{disclaimer}</Text>
        </Box>
    </Layer>
    )
}

export const FormStatusNotification = ({ header, subheader, subheader2, linkto = false, error = false }) => {

    // Default Success
    let borderStyle = { size: "small", side: "all", color: "ttok" }
    let fontColor = "ttok"
    let location = useLocation();

    if (error) {
        borderStyle = { size: "small", side: "all", color: "ttdown" }
        fontColor = "ttdown"
    }

    return (
        <Box background="light-1"
            elevation="xsmall"
            margin="medium"
            pad="small" direction="row" round="xsmall"
            gap="small" border={borderStyle}>

            {linkto &&
                <Link to={{pathname: linkto, search:location.search}}>
                    <Box gap="xsmall" pad="small" align="start">
                        {header &&
                        <Button plain label={<Text size="16px" color={fontColor} weight="bold">{header}</Text>} icon={!error ? <StatusGood size="medium" color={fontColor} /> : <StatusCritical size="medium" color={fontColor} />} />
                        }
                        {subheader && subheader.length > 0 &&
                            <Text size="13px" color={fontColor}> {subheader}</Text>
                        }

                        {subheader2 && subheader2.length > 0 &&
                            <Text size="13px" color={fontColor}>{subheader2}</Text>
                        }
                    </Box>
                </Link>
            }

            {!linkto &&
                <Box gap="xsmall" pad="small" align="start">
                    {header &&
                        <Button plain label={<Text size="16px" color={fontColor} weight="bold">{header}</Text>} icon={!error ? <StatusGood size="medium" color={fontColor} /> : <StatusCritical size="medium" color={fontColor} />} />
                    }
                    {subheader && subheader.length > 0 &&
                        <Text size="13px" color={fontColor}> {subheader}</Text>
                    }

                    {subheader2 && subheader2.length > 0 &&
                        <Text size="13px" color={fontColor}>{subheader2}</Text>
                    }
                </Box>
            }

        </Box>
    )
}

export default FormStatusNotification